import { Utils, Router, AppData, Registry, Log } from "@lightningjs/sdk";
import { Logger } from "../logger";
import axios from "axios";
import { AppSetup } from "../app-setup";
import { AppApiConfig, AppConfig } from "../app-api-config";
import { IDialogueButton, IDialogueInfo } from "../interfaces";
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from "../enum";
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import AppModel from "./app-model";

export type NetworkCallback = {
  success: Function,
  failed: Function
}

export default class NetworkManager {

  networkTimeoutIntv = 10000;
  networkTimeoutTimer: any;
  networkDialog = null;
  networkState = true;
  deviceNetworkConnected = true;
  showPopup = true;
  fnScope = null;
  fnRef!: NetworkCallback;

  webServerpingPath = '';
  CDNpingPath = '';
  isFailedTriggered = false
  controller: AbortController | null = null
  timeoutId: any

  listenerID = -55;

  constructor() {
    this.webServerpingPath = ''
    //this.webServerpingPath = 'https://testing2.freeawesometv.com/samsung/config/v4006/dist/es5/static/images/1x1.png'
  }

  getPingPath(): string {
    this.webServerpingPath = Utils.asset('/images/1x1.png')
    const { appConfig } = AppData as AppSetup
    if (appConfig?.nodeEnv === 'dev') {
      this.webServerpingPath = 'https://testing2.freeawesometv.com/samsung/config/v4006/dist/es5/static/images/1x1.png'
    }
    return this.webServerpingPath + '?r=' + new Date().getTime()
  }

  openNetworkDialog() {
    const dialogInfo: IDialogueInfo = {
      title: 'Network Connection',
      body: 'Network Disconnected - Trying to Reconnect',
      type: DIALOG_TYPE.NETWORK_BOX,
      callback: (selectedButton: IDialogueButton, dialogueInfo: IDialogueInfo) => {
        const { appState, platform } = AppData as AppSetup
        const app = appState?.getApp() as AppModel
        if (selectedButton.action == DIALOG_BUTTON_ACTION.CLOSE && platform && !platform.networkManager.isNetworkConnected()) {
          app.handleAppExit()
        }
      }
    }
    Router.getActivePage()?.widgets.dialog.showDialog(dialogInfo)
    Router.focusWidget('dialog')
  }

  closeNetworkDialog() {
    //$(networkDialog).fadeOut();
    //helper.hideConnectionErrorMsg();
    Router.getActivePage()?.widgets.dialog.hideDialog()
  }

  isNetworkConnected() {
    return this.networkState;
  }

  stopNetworkRetryTimeout() {
    clearInterval(this.networkTimeoutTimer);
  }

  startNetworkRetryTimeout() {
    //console.log('Poling- networkStatus')
    this.stopNetworkRetryTimeout();
    this.networkTimeoutTimer = setTimeout(() => {
      this.pollCheck();
    }, this.networkTimeoutIntv);
  }

  networkReconnected() {
    this.networkState = true;
    this.closeNetworkDialog();
    if (this.isFailedTriggered) {
      Logger.processUserAction('networkReconnected', ((new Date()).getTime()/1000).toString());
    } 
    if (this.fnRef && this.fnRef.success !== null) {
      this.fnRef.success.apply(this.fnScope, [this.isFailedTriggered]);
    }
  }


  networkDisconnected() {
    this.networkState = false;
    if (!this.isFailedTriggered) {
      if (this.showPopup) {
        this.openNetworkDialog();
      }
      if (this.fnRef && this.fnRef.failed !== null) {
        this.fnRef.failed.apply(this.fnScope);
      }
      this.isFailedTriggered = true
    }
    this.startNetworkRetryTimeout();
  }

  setNetworkState(state) {
    this.networkState = state
    const page = Router.getActivePage()
    if (page.$videoPlayerWaiting) {
      page.$videoPlayerWaiting()
    }
  }

  healthCheck(showConnBox = false, fnScope: any = null, fnRef: NetworkCallback) {
    this.showPopup = showConnBox;
    this.fnScope = fnScope;
    this.fnRef = fnRef
    this.isFailedTriggered = false
    if (this.controller) {
      clearTimeout(this.timeoutId);
      this.controller.abort(new TypeError('cancled'))
    }
    this.pollCheck()
  }

  async pollCheck() {

    if (navigator.onLine) {

      this.controller = new AbortController() as AbortController

      // 5 second timeout:
      this.timeoutId = setTimeout(() => this.controller.abort(new TypeError('timeout')), 5000)
      try {
        const response = await fetch(this.getPingPath(), { signal: this.controller.signal }); // Replace with a reliable endpoint
        if (response.ok) {
          Log.info("Connected to the internet!");
        } else {
          Log.info("Internet connection seems unstable!");
        }
        this.networkReconnected()
      } catch (error: any) {
        if (error.message !== 'cancled') {
          Log.info("No internet connection!", error);
          this.networkDisconnected()
        }
      }
      clearTimeout(this.timeoutId);
    } else {
      Log.info("No internet connection!");
      this.networkDisconnected()
    }
    // axios.get(this.webServerpingPath), {
    //   timeout: 5000,
    //   timeoutErrorMessage: 'Request Timed Out',
    //   headers: {
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': '0',
    //   }
    // }).then((resp) => {
    //   // if (fnRef && fnRef.success !== null) {
    //   //   fnRef.success.apply(fnScope);
    //   // }
    //   this.checkCDNStatus();
    //   this.networkReconnected();
    // }).catch(error => {

    //   //console.log(error)
    //   if (error.response) {
    //     // The request was made and the server responded with a status code
    //     // that falls out of the range of 2xx
    //     // console.log(error.response.data);
    //     // console.log(error.response.status);
    //     // console.log(error.response.headers);
    //     this.networkReconnected();
    //   } else if (error.request) {
    //     this.networkDisconnected();
    //     // The request was made but no response was received
    //     // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    //     // http.ClientRequest in node.js
    //     //console.log(error.request);
    //   } else {
    //     this.networkReconnected();
    //     //this.networkDisconnected();
    //     // Something happened in setting up the request that triggered an Error
    //     //console.log('Error', error.message);
    //   }
    // })

    // $.ajax({
    //     cache: false,
    //     url: ,

    //     success: function (data) {
    //         console.log('HealthCheck: Success');
    //         //delete ajaxRequestObj[id];
    //         if (fnRef !== null) {
    //             fnRef.apply(fnScope, fnParams);
    //         }
    //         checkCDNStatus();
    //         networkReconnected();
    //     }.bind(this),
    //     error: function (err) {
    //         if (err.status === 0) {
    //             console.log('HealthCheck: Internet Disconnected');
    //             networkDisconnected(showConnBox);
    //         } else {
    //             if (fnRef !== undefined) {
    //                 fnRef.apply(fnScope, fnParams);
    //             }
    //         }
    //     }.bind(this),
    //     // ,
    //     timeout: 5000
    // });
  }

  checkCDNStatus() {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()!
    const url = this.getCdnPath()
    axios.get(url + new Date().getTime(), {
      timeout: 5000,
      timeoutErrorMessage: 'Request Timed Out'
    }).then((resp) => {
      Log.info('CDN Ping: Success');
    }).catch(error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);

      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        //console.log(error.request);
        const { appState } = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig()!
        var errMsg = {
          status: error.message,
          countryCode: appApiConfig.userConfig.countryCode,
          cityName: appApiConfig.userConfig.cityName,
          url: url,
        };
        Logger.logUserAction('CDNError', JSON.stringify(errMsg))
      } else {
        // Something happened in setting up the request that triggered an Error
        // console.log('Error', error.message);
      }
      // if (xhr.status && xhr.status > 400) {
      //   var errMsg = {
      //     status: xhr.status,
      //     countryCode: appApiConfig.userConfig.countryCode,
      //     cityName: appApiConfig.userConfig.cityName,
      //     url: url,
      //   };
      //   //if status 400 means the server is available, but the resource images is replaced or deleted. in the path.
      //   // for our condition we only ping to check the dns server is not down hence we only log the
      //   // errors like
      //   // '401' : "Unauthorized access.",
      //   // '403' : "Forbidden resource can't be accessed.",
      //   // '500' : "Internal server error.",
      //   // '503' : "Service unavailable."

      //   Logger.processUserAction('CDNError', JSON.stringify(errMsg));
      // }
    })
    // $.ajax({
    //   cache: false,
    //   url: getCdnPath() + new Date().getTime(),

    //   success: function (data, textStatus, jqXHR) {
    //     Logger.printLog('info', 'CDN Ping: Success');
    //   }.bind(this),
    //   error: function (xhr, error, thrownError) {

    //     Logger.printLog('info', 'CDN Ping: failed', [xhr.status]);
    //     if (xhr.status && xhr.status > 400) {
    //       var errMsg = {
    //         status: xhr.status,
    //         countryCode: appApiConfig.userConfig.countryCode,
    //         cityName: appApiConfig.userConfig.cityName,
    //         url: url,
    //       };
    //       //if status 400 means the server is available, but the resource images is replaced or deleted. in the path.
    //       // for our condition we only ping to check the dns server is not down hence we only log the
    //       // errors like
    //       // '401' : "Unauthorized access.",
    //       // '403' : "Forbidden resource can't be accessed.",
    //       // '500' : "Internal server error.",
    //       // '503' : "Service unavailable."

    //       Logger.processUserAction('CDNError', JSON.stringify(errMsg));
    //     }
    //   }.bind(this),
    //   timeout: 5000
    // });
  }

  onChange(networkStat: boolean) {
    this.networkState = networkStat
  }

  getCdnPath() {
    const { appState } = AppData as AppSetup
    const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!

    var url = new URL(appApiConfig.appBrandConfig.header_logo)
    var pth = url.protocol + '//' + url.host + '/files/styles/hd_two_row_landscape/public/a8wn4hw/im/40/82/563850d47f14771fbd94c11f7fd2df23.jpg?';
    return pth;
  }
}
